import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: `/anunciante-estabelecimento`,

        async searchLocals({ estabeleshimentId }) {
            return Vue.http.get(this.url(`/${estabeleshimentId}/locais/`));
        }
    },
    base
);
